<template>
    <v-dialog v-model="mostrar" persistent max-width="900" scrollable>
		<v-card max-height="600px" max-width="900" class="mx-auto">
			<v-card-title class="primary white--text">Avisos <v-spacer></v-spacer>{{contador}} de {{avisos.length}}</v-card-title>
            <v-card-text class="pt-4">
            <h3 slot="header"></h3>
			<div slot="body">
				<div class="container">
					<div class="row">
						<div class="col">
							<div class="texto-aviso p-5" v-html="aviso.conteudo"></div>
						</div>
					</div>
				</div>
			</div>
            </v-card-text>
            <v-card-actions class="d-none d-sm-flex">
				<v-btn color="primary" text @click="chamaAvisoAnterior()">Anterior</v-btn>
				<v-btn color="primary" text @click="chamaProximoAviso()">Próximo</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="fechar()">Fechar</v-btn>
			</v-card-actions>
            <v-card-actions class="d-sm-none">
				<v-btn small color="primary" text @click="chamaAvisoAnterior()">Anterior</v-btn>
				<v-btn small color="primary" text @click="chamaProximoAviso()">Próximo</v-btn>
                <v-spacer></v-spacer>
                <v-btn small color="primary" text @click="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>

export default{
    props:['mostrar', 'avisos'],
    data(){
        return{
            aviso: {},
            contador: 1,
        }
    },
    methods:{
        fechar(){
            this.$emit('fecharAvisos')
        },

        chamaAvisoAnterior(){
            if(this.contador > 1){
                this.contador--
                this.aviso = this.avisos[this.contador -1]
            }
        },

        chamaProximoAviso(){
            if(this.avisos.length > this.contador){
                this.aviso = this.avisos[this.contador]
                this.contador++
            }
        },
    },
    watch:{
        mostrar(val){
            if(val){
                this.aviso = this.avisos[0]
            }
        }
    }
}
</script>

<style scoped>

</style>